import { render } from "./WebView.vue?vue&type=template&id=3a7a2d99&scoped=true&ts=true"
import script from "./WebView.vue?vue&type=script&lang=ts"
export * from "./WebView.vue?vue&type=script&lang=ts"

import "./WebView.vue?vue&type=style&index=0&id=3a7a2d99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7a2d99"],['__file',"src/components/WebView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a7a2d99"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a7a2d99', __exports__)) {
    api.reload('3a7a2d99', __exports__)
  }
  
  module.hot.accept("./WebView.vue?vue&type=template&id=3a7a2d99&scoped=true&ts=true", () => {
    api.rerender('3a7a2d99', render)
  })

}


export default __exports__